module.exports = __webpack_public_path__ + "img/arrow_left.26890a40.svg";